import * as types from "./app.actionTypes";
import { v4 as uuid } from "uuid";

import { bounds, boundsKg, oct_20_2 } from "./newCons";
const imfa_burden_mix_latest =
  JSON.parse(localStorage.getItem("imfa_burden_mix_latest")) || {};

const initialState = {
  client_id: uuid(),
  transform_controllers: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    data: null,
    error: null,
  },
  erp_file: {
    raw_file: null,
    converted_file: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  history: {
    isLoading: false,
    isError: false,
    data: [],
  },
  past_deviations: {
    isLoading: false,
    isError: false,
    data: [],
  },
  create_deviation: {
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  binStatus: {
    data: [
      {
        idx: 1,
        binName: "BIN 1",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 2,
        binName: "BIN 2",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 3,
        binName: "BIN 3",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 4,
        binName: "BIN 4",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 5,
        binName: "BIN 5",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 6,
        binName: "BIN 6",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 7,
        binName: "BIN 7",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 8,
        binName: "BIN 8",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 9,
        binName: "BIN 9",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 10,
        binName: "BIN 10",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 11,
        binName: "BIN 11",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
      {
        idx: 12,
        binName: "BIN 12",
        status: "NOT IN USE",
        lotNumber: null,
        category: null,
        statusQuote: "Optimizer will figure out the material and proportion",
      },
    ],
    jsonData: null,
    isLoading: false,
    isSuccess: true,
    isError: false,
    message: null,
    postDataForApi: null,
  },
  inputFile: null,

  bounds: oct_20_2,
  bounds_id: "",
  bounds_loading: false,
  bounds_success: false,
  bounds_failure: false,

  input_ore_material_sum: 1000,
  response_loading: false,
  response_success: false,
  response_failure: false,

  response: imfa_burden_mix_latest,
  response_failure_message: "",
};

export const app = (state = initialState, action) => {
  let { type, payload } = action;
  switch (type) {
    case types.EDIT_INPUT_ORE_MATERIAL_SUM: {
      return { ...state, input_ore_material_sum: payload };
    }
    case types.EDIT_BOUNDS_CONTROLLERS: {
      return { ...state, bounds: { ...state.bounds, controllers: payload } };
    }
    case types.EDIT_BOUNDS_CONSTRAINTS: {
      return { ...state, bounds: { ...state.bounds, constraints: payload } };
    }
    case types.EDIT_BOUNDS_ASSUMPTIONS: {
      return { ...state, bounds: { ...state.bounds, assumptions: payload } };
    }
    case types.EDIT_BOUNDS_WEIGHTAGE_FACTORS: {
      return {
        ...state,
        bounds: { ...state.bounds, weightage_factors: payload },
      };
    }
    case types.EDIT_BOUNDS_STEPS: {
      return {
        ...state,
        bounds: { ...state.bounds, steps: payload },
      };
    }
    case types.GET_CONSTRAINTS_LOADING: {
      return {
        ...state,
        bounds_loading: true,
        bounds_success: false,
        bounds_failure: false,
      };
    }
    case types.GET_CONSTRAINTS_SUCCESS: {
      // console.log("GET_CONSTRAINTS_SUCCESS : ", payload);
      return {
        ...state,
        bounds: payload.bounds,
        bounds_id: payload._id,
        bounds_loading: false,
        bounds_success: true,
        bounds_failure: false,
      };
    }
    case types.GET_CONSTRAINTS_FAILURE: {
      return {
        ...state,
        bounds_loading: false,
        bounds_success: false,
        bounds_failure: true,
      };
    }
    case types.RESPONSE_LOADING: {
      return {
        ...state,
        response_loading: true,
        response_success: false,
        response_failure: false,
      };
    }
    case types.RESPONSE_SUCCESS: {
      return {
        ...state,
        response: payload,
        response_loading: false,
        response_success: true,
        response_failure: false,
      };
    }
    case types.RESPONSE_FAILURE: {
      return {
        ...state,
        response_failure: true,
        response_loading: false,
        response_success: false,
        response_failure_message: payload,
      };
    }
    case types.ADD_FILE: {
      return { ...state, inputFile: payload };
    }
    case types.RESET_ERROR_LOADING_STATUS: {
      return {
        ...state,
        response_loading: false,
        response_success: false,
        response_failure: false,
      };
    }
    case types.GET_HISTORY_LOADING: {
      return {
        ...state,
        history: {
          ...state.history,
          isLoading: true,
          isError: false,
        },
      };
    }
    case types.GET_HISTORY_SUCCESS: {
      return {
        ...state,
        history: {
          ...state.history,
          isLoading: false,
          isError: false,
          data: payload,
        },
      };
    }
    case types.GET_HISTORY_FAILURE: {
      return {
        ...state,
        history: {
          ...state.history,
          isLoading: false,
          isError: true,
        },
      };
    }
    case types.GET_DEVIATION_LOADING: {
      return {
        ...state,
        past_deviations: {
          ...state.past_deviations,
          isLoading: true,
          isError: false,
        },
      };
    }
    case types.GET_DEVIATION_SUCCESS: {
      return {
        ...state,
        past_deviations: {
          ...state.past_deviations,
          isLoading: false,
          isError: false,
          data: payload,
        },
      };
    }
    case types.GET_DEVIATION_FAILURE: {
      return {
        ...state,
        past_deviations: {
          ...state.past_deviations,
          isLoading: false,
          isError: true,
        },
      };
    }
    case types.CREATE_DEVIATION_LOADING: {
      // console.log(types.CREATE_DEVIATION_LOADING);
      return {
        ...state,
        create_deviation: {
          isLoading: true,
          isSuccess: false,
          isError: false,
        },
      };
    }
    case types.CREATE_DEVIATION_SUCCESS: {
      // console.log(types.CREATE_DEVIATION_SUCCESS);
      return {
        ...state,
        create_deviation: {
          isLoading: false,
          isSuccess: true,
          isError: false,
        },
      };
    }
    case types.CREATE_DEVIATION_FAILURE: {
      // console.log(types.CREATE_DEVIATION_FAILURE);
      return {
        ...state,
        create_deviation: {
          isLoading: false,
          isSuccess: false,
          isError: true,
        },
      };
    }
    case types.ERP_FILE_UPLOAD: {
      console.log({ payload });
      return {
        ...state,
        erp_file: {
          ...state.erp_file,
          raw_file: payload,
        },
      };
    }
    case types.ERP_CONVERT_LOADING: {
      return {
        ...state,
        erp_file: {
          ...state.erp_file,
          isLoading: true,
          isSuccess: false,
          isError: false,
        },
      };
    }
    case types.ERP_CONVERT_SUCCESS: {
      return {
        ...state,
        erp_file: {
          ...state.erp_file,
          converted_file: payload,
          isLoading: false,
          isSuccess: true,
          isError: false,
        },
        inputFile: payload,
      };
    }
    case types.ERP_CONVERT_FAILURE: {
      return {
        ...state,
        erp_file: {
          ...state.erp_file,
          converted_file: null,
          isLoading: false,
          isSuccess: false,
          isError: true,
        },
      };
    }
    case types.TRANSFORM_CONTROLLERS_LOADING: {
      return {
        ...state,
        transform_controllers: {
          ...state.transform_controllers,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    }
    case types.TRANSFORM_CONTROLLERS_SUCCESS: {
      // console.log("CONTROLLERS FROM TRANSFORM : ", state.bounds.controllers);

      let controllers = state.bounds.controllers;

      controllers.forEach((elem, idx) => {
        // console.log("BEFORE : ", controllers[idx]);
        let { name } = elem;
        if (payload[name] !== undefined) {
          controllers[idx].value = payload[name];
        }
        // console.log("BEFORE : ", controllers[idx].value);
        delete controllers[idx][name];
      });

      let updatedState = {
        ...state,
        bounds: { ...state.bounds, controllers: controllers },
        transform_controllers: {
          ...state.transform_controllers,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: payload,
        },
      };

      // console.log("AFTER TRANSFORM ", { updatedState });
      return updatedState;
    }
    case types.TRANSFORM_CONTROLLERS_FAILURE: {
      return {
        ...state,
        transform_controllers: {
          ...state.transform_controllers,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    }

    case types.UPDATE_BIN_STATUS_DATA: {
      return {
        ...state,
        binStatus: {
          ...state.binStatus,

          data: payload,
        },
      };
    }

    case types.SAVE_JSON_DATA:
      return {
        ...state,
        binStatus: {
          ...state.binStatus,

          jsonData: payload,
        },
      };

    case types.UPDATE_BIN_STATUS:
      return {
        ...state,
        binStatus: {
          ...state.binStatus,
          message: payload.jsonData,
          isSuccess: payload.statusCode == 200 ? true : false,
        },
      };
    case types.UPDATE_BIN_STATUS_ERROR:
      return {
        ...state,
        binStatus: {
          ...state.binStatus,
          message: payload,
          isSuccess: false,
        },
      };
    case types.UPDATE_POST_DATA_OBJ:
      return {
        ...state,
        binStatus: {
          ...state.binStatus,
          postDataForApi: payload,
        },
      };
    default:
      return state;
  }
};
